import type { ScreenShape } from "./ScreenShape";

/** A value per screen shape — the closed union keeps every rule exhaustive. */
export type PerShape<T> = Record<ScreenShape, T>;

/** A layout value: the same for every shape, or one per shape. */
export type Responsive<T> = T | PerShape<T>;

function isPerShape<T>(value: Responsive<T>): value is PerShape<T> {
  return typeof value === "object" && value !== null && "desktop" in value && "mobile" in value && "mobile_landscape" in value;
}

/** The value for `shape`. */
export function resolveResponsive<T>(value: Responsive<T>, shape: ScreenShape): T {
  return isPerShape(value) ? value[shape] : value;
}
